import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'specific.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'commercialpackage.name_translated')} /></TableCell>
</>

export default React.memo(Row)
